<template>
  <div id="app">

    <!-- header title -->
    <j-headful :title="$route.meta.title"/>

    <!-- header border -->
    <j-header/>

    <!-- router -->
    <router-view/>

    <!-- notification screen -->
    <j-loading-screen
      ref="loadingScreen"
      :message="loading_message"/>
    <j-info-screen
      ref="infoScreen"
      :message="info_message"/>
    <j-problem-screen
      ref="problemScreen"
      :message="problem_message"
      :code="problem_code"/>
    <j-success-screen
      ref="successScreen"
      :message="success_message"/>

  </div>
</template>

<script>
/* eslint-disable vue/name-property-casing */
import jMixNotificationScreen from '@/mixins/components/notification-screen/jMixNotificationScreen';

export default {
  name: 'default',
  mixins: [jMixNotificationScreen],
};
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue